import React, { useMemo, useState, useEffect } from "react";

import { Button, Card, Col, Form, Image, Row, Modal, Table } from "@themesberg/react-bootstrap";
import { useHistory } from "react-router-dom";

import ConfiguratorStepper from "./ConfiguratorStepper";
import { useProductsByCountry, preloadAllProducts } from "../../../hooks/useProducts";
import { productService } from "../../../Service/AllSalestoolAPI";
import CreateProductForm from "./CreateProductForm";


import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faArrowLeft, faArrowRight, faMapMarkerAlt, faDownload, faSave } from "@fortawesome/free-solid-svg-icons";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import swal from "sweetalert";

import fuelDispenserImg from "../../../assets/img/Sales tool products/fuel dispenser.png";
import hydrogenImg from "../../../assets/img/Sales tool products/Hydrogen.png";
import optImg from "../../../assets/img/Sales tool products/OPT.png";
import carWashImg from "../../../assets/img/Sales tool products/car wash.png";
import eMobilityImg from "../../../assets/img/Sales tool products/e-mobality.png";
import wsmImg from "../../../assets/img/Sales tool products/web socket managament.png";
import salesMap from "../../../assets/img/Sales tool products/salesMap.png";
function useSessionState(key, initialValue) {
  return useState(initialValue);
}

const getImageSrc = (img) => {
  if (!img) return null;
  if (img.startsWith("http") || img.startsWith("data:") || img.startsWith("/static") || img.startsWith("data:image")) return img;
  return `data:image/png;base64,${img}`;
};

const countries = [
  {
    id: "india",
    name: "India",
    markerClass: "configutar-marker-india",
  },
  {
    id: "portugal",
    name: "Portugal",
    markerClass: "configutar-marker-portugal",
  },

  {
    id: "dubai",
    name: "Dubai",
    markerClass: "configutar-marker-dubai",
  },
  {
    id: "canada",
    name: "Canada",
    markerClass: "configutar-marker-canada",
  },
];

const mapZoomClasses = [
  "configutar-map-zoom-65",
  "configutar-map-zoom-80",
  "configutar-map-zoom-95",
  "configutar-map-zoom-110",
  "configutar-map-zoom-125",
  "configutar-map-zoom-140",
];

const productsByCountry = {
  india: [
    { name: "Fuel Dispenser", shortName: "FD" },
    { name: "Hydrogen", shortName: "H2" },
    { name: "OPT", shortName: "OPT" },
    { name: "Car Wash", shortName: "CW" },
    { name: "e-Mobility", shortName: "EV" },
    { name: "Wet Stock Management", shortName: "WSM" },
  ],
  portugal: [
    { name: "Fuel Dispenser", shortName: "FD" },
    { name: "OPT", shortName: "OPT" },
    { name: "Car Wash", shortName: "CW" },
    { name: "e-Mobility", shortName: "EV" },
  ],

  dubai: [
    { name: "Fuel Dispenser", shortName: "FD" },
    { name: "OPT", shortName: "OPT" },
    { name: "e-Mobility", shortName: "EV" },
    { name: "Wet Stock Management", shortName: "WSM" },
  ],
  canada: [
    { name: "Hydrogen", shortName: "H2" },
    { name: "Car Wash", shortName: "CW" },
    { name: "e-Mobility", shortName: "EV" },
    { name: "Wet Stock Management", shortName: "WSM" },
  ],
};




const productImageMap = {
  "Fuel Dispenser": fuelDispenserImg,
  Hydrogen: hydrogenImg,
  OPT: optImg,
  "Car Wash": carWashImg,
  "e-Mobility": eMobilityImg,
  "Wet Stock Management": wsmImg,
};

const modelVisualMap = {
  "Fuel Dispenser": {
    "1111": {
      title: "Axon I ",
      image: require("../../../assets/img/Sales tool products/Axon I -premiun.png"),
      footerDisplayName: "Premium",
    },
    "2422": {
      title: "Axon I ",
      image: require("../../../assets/img/Sales tool products/Axon I-Classic.png"),
      footerDisplayName: "Classic",
    },
    Fenix: {
      title: "Fenix ",
      image: require("../../../assets/img/Sales tool products/Fenix- DEF.png"),
      footerDisplayName: "DEF",
    },
  },

  Hydrogen: {
    "H2-Standard": {
      title: "Hydrogen Standard",
      image: hydrogenImg,
    },
  },

  OPT: {
    "OPT-Prime": {
      title: "OPT Prime",
      image: optImg,
    },
  },

  "Car Wash": {
    "CW-Pro": {
      title: "Car Wash Pro",
      image: carWashImg,
    },
  },

  "e-Mobility": {
    "EV-Go": {
      title: "EV Go",
      image: eMobilityImg,
    },
  },

  "Wet Stock Management": {
    "WSM-Plus": {
      title: "WSM Plus",
      image: wsmImg,
    },
  },
};

const ELECTRONICS = {
  "Mother Board": ["Version 1", "Version 2"],
  Totalizer: ["Version 1", "Version 2"],
  "CSD Display": ["COB", "COG"],
  "Segment Type": ["Amber + Black", "Black + White"],
  Keypad: ["5*4"],
  Printer: ["PT102"],
  Pulser: ["Hall Effect – External", "Hall Effect – Magnetic"],
};

const MECHANICAL = {
  "Shear Valve": ["EMCO", "Infinity", "Kaanra"],
  "Inlet Filter": ["Local SS – 25Micron", "Local – 40Micron", "Local SS – 80 Micron"],
  "PD Meter": ["PTF 25"],
  "Solenoid Valve": ["ASCO Local", "ASCO International", "Infinity"],
  "Column Elbow": ["Non-VRS", "VRS", "SS"],
  "Pump Break away": ["Elaflex", "Infinity", "Kaanra"],
  Hose: ["Polyhose", "Elaflex", "OPW", "Chinabotai", "XFY"],
  "Sight flow": ["Infinity", "Kaanra", "OPW", "Elaflex"],
  "Swivel Coupling": [
    "Infinity",
    "Kaanra",
    "OPW",
    "Elaflex Single Plane",
    "Double Plane",
  ],
  "Nozzle Break away": ["Infinity", "Kaanra", "OPW"],
  Nozzle: ["Elaflex", "Kaanra", "OPW", "Hopetrol", "China Botai", "Datian"],
  Protocol: ["Petrocal", "DART", "Tatsuno", "GVR 2WR"],
};

const ELECTRICAL = {
  "Standard Package": ["Standard Package"],
  "Cable Harness": ["Standard Package"],
};

const OPTIONS = {
  IoT: ["Yes", "No"],
  EMT: ["Yes", "No"],
  "Extended Display": ["Yes", "No"],
  "VRS Monitoring": ["Yes", "No"],
  "Door Sensor": ["Electronics", "Electro mechanical"],
  "Sealing Cover": ["Yes", "No"],
  "Sealing Wire": ["Yes", "No"],
  "Hose Retraction": ["Yes", "No"],
  "Junction Box": ["Standard", "Additional"],
  Multimedia: ["Yes", "No"],
  "OPT Slider": ["Yes", "No"],
  "Voltage Monitor": ["Yes", "No"],
};

const SectionForm = ({ title, options, values, onChange }) => {
  const entries = Object.entries(options);
  return (
    <>
      <h5 className="mb-3">{title}</h5>
      <Row>
        {entries.map(([label, opts]) => (
          <Col key={label} md={4} className="mb-3">
            <Form.Group>
              <Form.Label>{label}</Form.Label>
              <Form.Select
                value={values[label] || ""}
                onChange={(e) => onChange(label, e.target.value)}
                className={!values[label] ? "border-warning border-2" : "border-success border-2"}
              >
                <option value="">Select</option>
                {opts.map((opt) => (
                  <option key={opt} value={opt}>
                    {opt}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>
        ))}
      </Row>
    </>
  );
};

const ProductVisual = ({ productName, shortName }) => {
  const imgSrc = productImageMap[productName];

  if (imgSrc) {
    return (
      <>
        <img
          src={imgSrc}
          alt={shortName || productName}
          className="configutar-product-image"
          loading="lazy"
          onError={(e) => {
            e.currentTarget.style.display = "none";
            const container = e.currentTarget.parentElement;
            if (container) {
              const fallback = container.querySelector(
                "[data-fallback='product-" + productName + "']"
              );
              if (fallback) fallback.style.display = "block";
            }
          }}
        />
        <small data-fallback={`product-${productName}`} className="configutar-product-fallback">
          {shortName || productName}
        </small>
      </>
    );
  }

  return <div className="configutar-product-visual">{shortName || productName}</div>;
};

const ModelVisual = ({ category, model }) => {
  const modelData = modelVisualMap?.[category]?.[model];
  const title = modelData?.title || model;
  const image = modelData?.image;
  const footerDisplayName = modelData?.footerDisplayName;

  if (!modelData) {
    return (
      <div className="configutar-model-visual configutar-model-visual-fallback d-flex flex-column align-items-center">
        <strong className="configutar-model-title configutar-model-title-fallback">
          {title}
        </strong>

        <div className="configutar-model-frame configutar-model-frame-fallback">
          {image ? (
            <img
              src={image}
              alt={title}
              className="configutar-model-image configutar-model-image-fallback"
              onError={(e) => {
                e.currentTarget.style.display = "none";
              }}
            />
          ) : (
            model
          )}
        </div>

        {footerDisplayName && <small className="configutar-model-footer">{footerDisplayName}</small>}
      </div>
    );
  }

  return (
    <div className="configutar-model-visual d-flex flex-column align-items-center">
      <strong className="configutar-model-title">{title}</strong>

      <div className="configutar-model-frame configutar-model-frame-large">
        {image ? (
          <img src={image} alt={title} className="configutar-model-image configutar-model-image-large" />
        ) : (
          model
        )}
      </div>

      {footerDisplayName && <small className="configutar-model-footer">{footerDisplayName}</small>}
    </div>
  );
};

const Configutar = () => {
  useEffect(() => {
    preloadAllProducts();
  }, []);

  const [selectedCountry, setSelectedCountry] = useSessionState("configutar:selectedCountry", null);

  // Screen flow
  // "map" -> "countryProducts" -> "categoryModels" -> "baseSelections"
  // Standard/Custom is rendered on the baseSelections page (no separate screens).
  const [screen, setScreen] = useSessionState("configutar:screen", "map");
  const [mapZoomIndex, setMapZoomIndex] = useSessionState("configutar:mapZoomIndex", 0);

  // Step 2 selections
  const [selectedCategory, setSelectedCategory] = useSessionState("configutar:selectedCategory", null); // product type
  const [selectedModel, setSelectedModel] = useSessionState("configutar:selectedModel", null);

  const [vrsSelection, setVrsSelection] = useSessionState("configutar:vrsSelection", null); // Yes/No dropdown
  const [duTypeSelection, setDuTypeSelection] = useSessionState("configutar:duTypeSelection", null); // Pressure/Suction dropdown
  const [flowRateSelection, setFlowRateSelection] = useSessionState("configutar:flowRateSelection", null); // Flow Rate dropdown (Excel-backed)

  const [standardOrCustom, setStandardOrCustom] = useSessionState("configutar:standardOrCustom", null);
  const [isPdfLoading, setIsPdfLoading] = useState(false);

  // Commercial Terms Modal State
  const [showCommercialModal, setShowCommercialModal] = useState(false);
  const [isDraftSaving, setIsDraftSaving] = useState(false);
  const [isDraftSaved, setIsDraftSaved] = useState(false);
  const [commercialData, setCommercialData] = useState({
    customerName: "",
    customerAddress: "",
    country: "",
    currency: "",
    paymentTerms: "",
    deliveryTerms: "Ex Works",
    deliveryTimeline: "",
    expectedPODate: "",
    remarks: "",
    quantity: "",
    certifications: [],
    uploadedFile: null
  });

  const handleCountryChange = (e) => {
    const country = e.target.value;
    setCommercialData((prev) => ({
      ...prev,
      country,
      currency: country.toLowerCase() === "india" ? "INR" : "USD"
    }));
  };

  const handleSaveAsDraft = async () => {
    setIsDraftSaving(true);
    try {
      let bomcomponentsList = [];
      if (componentsData) {
        const processItem = (item, verticalKey = "") => {
          const dynamicKey = Object.keys(item).find(k => k !== 'pkComponentId' && k !== 'ptItemCodePart' && k !== 'piDescription' && k !== 'partCategory');
          return {
            ...item,
            piItemCodePart: item.ptItemCodePart || item.piItemCodePart || "",
            piDescription: item.piDescription || "",
            vertical: item.vertical || verticalKey || "",
            type: item.type || "",
            partCategory: item.partCategory || "",
            supplier: item.supplier || "",
            modelConfiguration: standardOrCustom ? standardOrCustom.charAt(0).toUpperCase() + standardOrCustom.slice(1) : "",
            quantity: {
              productname: dynamicKey || "",
              value: dynamicKey ? (Number(item[dynamicKey]) || 1) : 1
            }
          };
        };

        if (Array.isArray(componentsData)) {
          bomcomponentsList = componentsData.map(item => processItem(item));
        } else if (typeof componentsData === 'object') {
          Object.entries(componentsData).forEach(([key, arr]) => {
            if (Array.isArray(arr)) {
              bomcomponentsList = bomcomponentsList.concat(arr.map(item => processItem(item, key)));
            }
          });
        }
      }

      const currentDuConfiguration = configData ? (Array.isArray(configData) ? configData[0]?.duConfiguration : configData?.duConfiguration) : "";

      const payload = {
        quote: {
          product: selectedCategory || "",
          subProduct: selectedSubProductObj?.subProductName || selectedModel || "",
          type: selectedTypeObj?.typeName || modelVisualMap?.[selectedCategory]?.[selectedModel]?.footerDisplayName || standardOrCustom || "",
          modelNumber: selectedModel || "",
          duType: duTypeSelection || "",
          flowRate: flowRateSelection || "",
          vrs: vrsSelection || "",
          description: "",
          customerName: commercialData.customerName || "",
          country: commercialData.country || selectedCountry?.name || "",
          createdBy: sessionStorage.getItem("userName") || "",
          date: new Date().toISOString(),
          createdDate: new Date().toISOString(),
          quantity: commercialData.quantity ? parseInt(commercialData.quantity, 10) : 1,
          currency: commercialData.currency || "",
          quoteValue: 0,
          remarks: commercialData.remarks || "",
          query: "",
          configurationType: currentDuConfiguration || "",
          status: "Draft",
          department: "SALES"
        },
        commercialTerms: {
          customerName: commercialData.customerName || "",
          customerAddress: commercialData.customerAddress || "",
          country: commercialData.country || "",
          currency: commercialData.currency || "",
          paymentTerms: commercialData.paymentTerms || "",
          deliveryTerms: commercialData.deliveryTerms || "",
          deliveryTimeline: commercialData.deliveryTimeline || "",
          expectedPODate: commercialData.expectedPODate || "",
          remarks: commercialData.remarks || "",
          quantity: commercialData.quantity ? parseInt(commercialData.quantity, 10) : 1,
          certifications: Array.isArray(commercialData.certifications) ? commercialData.certifications.join(",") : (commercialData.certifications || ""),
          type: standardOrCustom || "",
          uploadedFile: commercialData.uploadedFile || null,
        },
        bomcomponents: bomcomponentsList
      };

      await productService.saveAsDraft(payload);
      swal("Success", "Draft saved successfully", "success");
      setIsDraftSaved(true);
      setShowCommercialModal(false);
    } catch (error) {
      swal("Error", "Failed to save draft", "error");
    } finally {
      setIsDraftSaving(false);
    }
  };

  const history = useHistory();
  const [accessError, setAccessError] = useState("");

  const activeStep =
    screen === "map"
      ? 0
      : screen === "countryProducts"
        ? 1
        : screen === "subProducts"
          ? 2
          : screen === "subProductTypes"
            ? 3
            : screen === "baseSelections"
              ? 4
              : 5;

  const [activeTab, setActiveTab] = useSessionState("configutar:activeTab", "Electronics");
  const [electronicsValues, setElectronicsValues] = useSessionState("configutar:electronicsValues", {});
  const [mechanicalValues, setMechanicalValues] = useSessionState("configutar:mechanicalValues", {});
  const [electricalValues, setElectricalValues] = useSessionState("configutar:electricalValues", {});
  const [optionsValues, setOptionsValues] = useSessionState("configutar:optionsValues", {});
  const [tabSaved, setTabSaved] = useSessionState("configutar:tabSaved", {
    Electronics: false,
    Mechanical: false,
    Electrical: false,
    Options: false,
  });
  const [submitted, setSubmitted] = useSessionState("configutar:submitted", false);

  const onChangeTabField = (fieldLabel, value) => {
    setTabSaved((prev) => ({ ...prev, [activeTab]: false }));
    if (activeTab === "Electronics") {
      setElectronicsValues((prev) => ({ ...prev, [fieldLabel]: value }));
    } else if (activeTab === "Mechanical") {
      setMechanicalValues((prev) => ({ ...prev, [fieldLabel]: value }));
    } else if (activeTab === "Electrical") {
      setElectricalValues((prev) => ({ ...prev, [fieldLabel]: value }));
    } else if (activeTab === "Options") {
      setOptionsValues((prev) => ({ ...prev, [fieldLabel]: value }));
    }
  };

  const getActiveValues = () => {
    if (activeTab === "Electronics") return electronicsValues;
    if (activeTab === "Mechanical") return mechanicalValues;
    if (activeTab === "Electrical") return electricalValues;
    return optionsValues;
  };

  const getActiveOptions = () => {
    if (activeTab === "Electronics") return ELECTRONICS;
    if (activeTab === "Mechanical") return MECHANICAL;
    if (activeTab === "Electrical") return ELECTRICAL;
    return OPTIONS;
  };

  const getTabProgress = (tabName) => {
    let options = {};
    let values = {};
    if (tabName === "Electronics") {
      options = ELECTRONICS;
      values = electronicsValues;
    } else if (tabName === "Mechanical") {
      options = MECHANICAL;
      values = mechanicalValues;
    } else if (tabName === "Electrical") {
      options = ELECTRICAL;
      values = electricalValues;
    } else if (tabName === "Options") {
      options = OPTIONS;
      values = optionsValues;
    }

    const totalFields = Object.keys(options).length;
    if (totalFields === 0) return 0;

    const filledFields = Object.keys(options).filter(key => values[key] && values[key] !== "").length;
    return (filledFields / totalFields) * 100;
  };

  const canSubmit = tabSaved.Electronics && tabSaved.Mechanical && tabSaved.Electrical && tabSaved.Options;

  const handleSaveTab = () => {
    const isActiveTabFilled = getTabProgress(activeTab) === 100;
    if (!isActiveTabFilled) {
      swal("Incomplete form", `Please fill all fields in the ${activeTab} tab.`, "warning");
      return;
    }

    setTabSaved((prev) => ({ ...prev, [activeTab]: true }));
    setSubmitted(false);
    swal("Saved", `${activeTab} data saved successfully.`, "success");
  };

  const tabItems = ["Electronics", "Mechanical", "Electrical", "Options"];

  const { data: apiData, loading: apiLoading, error: apiError } = useProductsByCountry(selectedCountry?.name);

  const [showCreateModal, setShowCreateModal] = useState(false);
  const [hoveredBtn, setHoveredBtn] = useState(null);

  const handleStepClick = (stepIndex) => {
    if (stepIndex === 0) setScreen("map");
    if (stepIndex === 1 && selectedCountry) setScreen("countryProducts");
    if (stepIndex === 2 && selectedCategory) setScreen("subProducts");
    if (stepIndex === 3 && selectedSubProductObj) setScreen("subProductTypes");
    if (stepIndex === 4 && selectedTypeObj) setScreen("baseSelections");
    if (stepIndex === 5 && standardOrCustom === "custom") setScreen("customConfigurator");
  };

  const [selectedProductObj, setSelectedProductObj] = useState(null);
  const [selectedSubProductObj, setSelectedSubProductObj] = useState(null);
  const [selectedTypeObj, setSelectedTypeObj] = useState(null);

  const [modelOptions, setModelOptions] = useState([]);
  const [loadingModelOptions, setLoadingModelOptions] = useState(false);

  const [duTypeOptions, setDuTypeOptions] = useState([]);
  const [loadingDuTypeOptions, setLoadingDuTypeOptions] = useState(false);

  const [flowRateOptions, setFlowRateOptions] = useState([]);
  const [loadingFlowRateOptions, setLoadingFlowRateOptions] = useState(false);

  const [baseOptionsError, setBaseOptionsError] = useState(null);

  useEffect(() => {
    if (screen === "baseSelections" && selectedTypeObj) {
      setLoadingModelOptions(true);
      setBaseOptionsError(null);
      productService.getConfiguration({ type: selectedTypeObj.typeName })
        .then(data => {
          const arr = Array.isArray(data) ? data : data ? [data] : [];
          setModelOptions(arr);
        })
        .catch(err => setBaseOptionsError(err.message || "Failed to load models"))
        .finally(() => setLoadingModelOptions(false));
    }
  }, [screen, selectedTypeObj]);

  useEffect(() => {
    if (selectedModel && selectedTypeObj) {
      setLoadingDuTypeOptions(true);
      productService.getConfiguration({ type: selectedTypeObj.typeName, model: selectedModel })
        .then(data => {
          const arr = Array.isArray(data) ? data : data ? [data] : [];
          setDuTypeOptions(arr);
        })
        .catch(err => console.error(err))
        .finally(() => setLoadingDuTypeOptions(false));
    } else {
      setDuTypeOptions([]);
    }
  }, [selectedModel, selectedTypeObj]);

  useEffect(() => {
    if (duTypeSelection && selectedModel && selectedTypeObj) {
      setLoadingFlowRateOptions(true);
      productService.getConfiguration({ type: selectedTypeObj.typeName, model: selectedModel, duType: duTypeSelection })
        .then(data => {
          const arr = Array.isArray(data) ? data : data ? [data] : [];
          setFlowRateOptions(arr);
        })
        .catch(err => console.error(err))
        .finally(() => setLoadingFlowRateOptions(false));
    } else {
      setFlowRateOptions([]);
    }
  }, [duTypeSelection, selectedModel, selectedTypeObj]);

  const [configData, setConfigData] = useState(null);
  const [loadingConfig, setLoadingConfig] = useState(false);
  const [configError, setConfigError] = useState(null);

  const [componentsData, setComponentsData] = useState(null);
  const [loadingComponents, setLoadingComponents] = useState(false);
  const [componentsError, setComponentsError] = useState(null);

  const fetchComponents = async (type, destinationScreen) => {
    setStandardOrCustom(type);
    sessionStorage.setItem("configutar:standardOrCustom", type);

    if (!configData) return;
    const config = Array.isArray(configData) ? configData[0] : configData;

    setLoadingComponents(true);
    setComponentsError(null);
    try {
      const payload = {
        vrs: config.vrs,
        duType: config.duType,
        flowRate: config.flowRate,
        duConfiguration: config.duConfiguration,
        subProductName: selectedSubProductObj?.subProductName || selectedModel || selectedCategory || ""
      };
      const result = await productService.getComponentAgainstDuConfiguration(payload);
      setComponentsData(result);
      console.log("Components fetched:.......", result);

      // Navigate to next screen
      if (destinationScreen) {
        setScreen(destinationScreen);
      }
    } catch (err) {
      setComponentsError(err.message || "Failed to load components");
    } finally {
      setLoadingComponents(false);
    }
  };

  // Fetch final configuration when all base selections are complete
  useEffect(() => {
    const isStep2Ready = Boolean(selectedModel && duTypeSelection && flowRateSelection);
    if (screen === "baseSelections" && isStep2Ready) {
      setLoadingConfig(true);
      setConfigError(null);
      productService.getConfiguration({
        model: selectedModel,
        duType: duTypeSelection,
        type: selectedTypeObj?.typeName,
        flowRate: flowRateSelection
      })
        .then(data => {
          setConfigData(data);
          const vrsVal = Array.isArray(data) ? data[0]?.vrs : data?.vrs;
          if (vrsVal) setVrsSelection(vrsVal);
        })
        .catch(err => setConfigError(err.message || "Failed to load configuration"))
        .finally(() => setLoadingConfig(false));
    }
  }, [screen, selectedModel, duTypeSelection, selectedTypeObj, flowRateSelection, vrsSelection]);

  const handleExcelDownload = () => {
    if (!componentsData || Object.keys(componentsData).length === 0) return;
    const workbook = XLSX.utils.book_new();

    Object.keys(componentsData).forEach((tabName) => {
      const data = componentsData[tabName];
      if (data && data.length > 0) {
        const worksheet = XLSX.utils.json_to_sheet(data);
        // Excel worksheet names must be <= 31 characters
        const safeTabName = tabName.substring(0, 31);
        XLSX.utils.book_append_sheet(workbook, worksheet, safeTabName);
      }
    });

    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    saveAs(blob, `All_Components.xlsx`);
  };

  const handlePdfDownload = async () => {
    if (!componentsData || Object.keys(componentsData).length === 0) return;

    const config = Array.isArray(configData) ? configData[0] : configData;
    if (!config) return;

    try {
      setIsPdfLoading(true);
      const payload = {
        vrs: config.vrs,
        duType: config.duType,
        flowRate: config.flowRate,
        duConfiguration: config.duConfiguration,
        modelNumber: selectedModel,
        type: selectedTypeObj?.typeName,
        subProductName: selectedSubProductObj?.subProductName || selectedModel || selectedCategory || ""
      };

      const response = await productService.getComponentPdfDownload(payload);
      const blob = new Blob([response.data], { type: "application/pdf" });
      saveAs(blob, `BOM_Report.pdf`);
    } catch (error) {
      console.error("PDF Download Error:", error);
    } finally {
      setIsPdfLoading(false);
    }
  };

  useEffect(() => {
    if (standardOrCustom === "standard" && componentsData) {
      const keys = Object.keys(componentsData);
      if (keys.length > 0 && !keys.includes(activeTab)) {
        setActiveTab(keys[0]);
      }
    }
  }, [componentsData, standardOrCustom, activeTab, setActiveTab]);
  const stepSelections = {
    country: selectedCountry?.name || "",
    product: selectedCategory || "",
    subProduct: selectedSubProductObj?.subProductName || selectedModel || "",
    type: selectedTypeObj?.typeName || "",
    standardOrCustom: standardOrCustom || "",
    customConfigurator: submitted ? "Done" : "",
  };
  const configutarSelectedCategoryForStepper = selectedCategory ? selectedCategory : "";


  // products list for selected country (map pin -> country products)

  const products = productsByCountry[selectedCountry?.id] || [];


  const zoomIn = () =>
    setMapZoomIndex((zoomIndex) => Math.min(mapZoomClasses.length - 1, zoomIndex + 1));
  const zoomOut = () =>
    setMapZoomIndex((zoomIndex) => Math.max(0, zoomIndex - 1));


  const modelOptionsByCategory = useMemo(() => {
    return {
      "Fuel Dispenser": [
        {
          model: "1111",
          vrsOptions: ["Yes", "No"],
          duTypeOptions: ["Pressure", "Suction"],
          flowRateOptions: ["0.5 - 1.0", "1.0 - 2.0", "2.0 - 4.0"],
        },
        {
          model: "2422",
          vrsOptions: ["Yes", "No"],
          duTypeOptions: ["Pressure", "Suction"],
          flowRateOptions: ["1.0 - 2.5", "2.5 - 5.0"],
        },
        {
          model: "Fenix",
          vrsOptions: ["Yes", "No"],
          duTypeOptions: ["Pressure", "Suction"],
          flowRateOptions: ["1.0 - 2.5", "2.5 - 5.0"],
        },
      ],

      Hydrogen: [
        {
          model: "H2-Standard",
          vrsOptions: ["No"],
          duTypeOptions: ["Pressure"],
          flowRateOptions: ["0.2 - 0.5", "0.5 - 1.0"],
        },
      ],
      OPT: [
        {
          model: "OPT-Prime",
          vrsOptions: ["Yes"],
          duTypeOptions: ["Pressure"],
          flowRateOptions: ["1.0 - 2.0"],
        },
      ],
      "Car Wash": [
        {
          model: "CW-Pro",
          vrsOptions: ["Yes", "No"],
          duTypeOptions: ["Suction"],
          flowRateOptions: ["0.8 - 1.6", "1.6 - 3.2"],
        },
      ],
      "e-Mobility": [
        {
          model: "EV-Go",
          vrsOptions: ["No"],
          duTypeOptions: ["Pressure"],
          flowRateOptions: ["0.6 - 1.2"],
        },
      ],
      "Wet Stock Management": [
        {
          model: "WSM-Plus",
          vrsOptions: ["Yes"],
          duTypeOptions: ["Pressure", "Suction"],
          flowRateOptions: ["1.2 - 2.4"],
        },
      ],
    };
  }, []);

  const resetSelections = () => {
    setSelectedCategory(null);
    setSelectedModel(null);
    setVrsSelection(null);
    setDuTypeSelection(null);
    setFlowRateSelection(null);
    setStandardOrCustom(null);
    setAccessError("");
    setSelectedProductObj(null);
    setSelectedSubProductObj(null);
    setSelectedTypeObj(null);
  };


  const goToCountryProducts = () => {
    resetSelections();
    setScreen("countryProducts");
  };

  const goToSubProducts = (productObj) => {
    setSelectedProductObj(productObj);
    setSelectedCategory(productObj.productName);
    setScreen("subProducts");
  };

  const goToSubProductTypes = (subProductObj) => {
    setSelectedSubProductObj(subProductObj);
    // User wants to fill Model manually on the final screen, so we don't pre-fill it here
    setScreen("subProductTypes");
  };

  const goToBaseSelections = (typeObj) => {
    setSelectedTypeObj(typeObj);
    setVrsSelection(null);
    setDuTypeSelection(null);
    setFlowRateSelection(null);
    setScreen("baseSelections");
  };

  const subProductImageMapByCategory = {
    // sub-product image should be shown based on model code,
    // so we don't render a generic sub-product at this step.
  };





  const isStep2Ready = Boolean(vrsSelection && duTypeSelection && flowRateSelection);

  if (screen === "countryProducts") {
    return (
      <div className="py-4 sales-tool-root">
        <ConfiguratorStepper activeStep={activeStep} selections={stepSelections} onStepClick={handleStepClick} />
        {accessError || apiError ? (
          <div className="alert alert-danger text-center" role="alert">
            Data failed to load. Please try again.
          </div>
        ) : null}
        <Card border="light" className="shadow-sm">
          <Card.Body>
            <div className="configutar-product-header">
              <div className="configutar-country-title">
                <h4 className="mb-0">{selectedCountry.name} Products</h4>
              </div>

              <Button
                variant="outline-primary"
                className="configutar-back-button"
                onClick={() => {
                  resetSelections();
                  setSelectedCountry(null);
                  setScreen("map");
                }}
              >
                <FontAwesomeIcon icon={faArrowLeft} />
                Back
              </Button>
            </div>

            {apiLoading ? (
              <div className="text-center p-4">
                <div className="spinner-border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : (
              <div style={{ maxHeight: "55vh", overflowY: "auto", overflowX: "hidden" }} className="p-1">
                <Row className="g-2">
                  {Array.isArray(apiData) && apiData.map((product) => (
                    <Col key={product.id || product.productName} xs={6} sm={4} lg={3} className="d-flex justify-content-center">
                      <button
                        type="button"
                        className={`btn configutar-model-selector-button ${selectedProductObj?.id === product.id || selectedCategory === product.productName ? "selected" : ""}`}
                        onClick={() => goToSubProducts(product)}
                      >
                        <div className="d-flex flex-column align-items-center">
                          <strong className="configutar-model-title mb-2">{product.productName}</strong>
                          <div className="configutar-model-frame configutar-model-frame-large">
                            {product.productImage && (
                              <img src={getImageSrc(product.productImage)} alt={product.productName} className="configutar-model-image configutar-model-image-large" loading="lazy" />
                            )}
                          </div>
                        </div>
                      </button>
                    </Col>
                  ))}
                </Row>
              </div>
            )}
          </Card.Body>
        </Card>
      </div>
    );
  }

  if (screen === "subProducts") {
    return (
      <div className="py-4 sales-tool-root">
        <ConfiguratorStepper activeStep={activeStep} selections={stepSelections} onStepClick={handleStepClick} />
        <Card border="light" className="shadow-sm">
          <Card.Body>
            <div className="configutar-product-header">
              <div className="configutar-country-title">
                <h4 className="mb-0 d-flex align-items-center">
                  {selectedCountry.name} <FontAwesomeIcon icon={faArrowRight} className="mx-2 text-muted" size="sm" /> {selectedCategory} (Sub Products)
                </h4>
              </div>

              <div className="d-flex gap-2">
                <Button
                  variant="outline-primary"
                  className="configutar-back-button"
                  onClick={() => {
                    setSelectedProductObj(null);
                    setSelectedCategory(null);
                    setScreen("countryProducts");
                  }}
                >
                  <FontAwesomeIcon icon={faArrowLeft} />
                  Back
                </Button>
              </div>
            </div>

            <div style={{ maxHeight: "55vh", overflowY: "auto", overflowX: "hidden" }} className="p-1">
              <Row className="g-2">
                {selectedProductObj?.subProductDetails?.map((subProduct) => (
                  <Col key={subProduct.id} xs={6} sm={4} lg={3} className="d-flex justify-content-center">
                    <button
                      type="button"
                      className={`btn configutar-model-selector-button ${selectedSubProductObj?.id === subProduct.id || selectedModel === subProduct.subProductName ? "selected" : ""}`}
                      onClick={() => goToSubProductTypes(subProduct)}
                    >
                      <div className="d-flex flex-column align-items-center">
                        <strong className="configutar-model-title">{subProduct.subProductName}</strong>
                        <div className="configutar-model-frame configutar-model-frame-large">
                          {subProduct.subProductImage && (
                            <img src={getImageSrc(subProduct.subProductImage)} alt={subProduct.subProductName} className="configutar-model-image configutar-model-image-large" />
                          )}
                        </div>
                      </div>
                    </button>
                  </Col>
                ))}
              </Row>
            </div>
          </Card.Body>
        </Card>
      </div>
    );
  }

  if (screen === "subProductTypes") {
    return (
      <div className="py-4 sales-tool-root">
        <ConfiguratorStepper activeStep={activeStep} selections={stepSelections} onStepClick={handleStepClick} />
        <Card border="light" className="shadow-sm">
          <Card.Body>
            <div className="configutar-product-header">
              <div className="configutar-country-title">
                <h4 className="mb-0 d-flex align-items-center">
                  {selectedCountry.name} <FontAwesomeIcon icon={faArrowRight} className="mx-2 text-muted" size="sm" /> {selectedCategory} <FontAwesomeIcon icon={faArrowRight} className="mx-2 text-muted" size="sm" /> {selectedSubProductObj?.subProductName} (Types)
                </h4>
              </div>

              <div className="d-flex gap-2">
                <Button
                  variant="outline-primary"
                  className="configutar-back-button"
                  onClick={() => {
                    setSelectedSubProductObj(null);
                    setSelectedModel(null);
                    setScreen("subProducts");
                  }}
                >
                  <FontAwesomeIcon icon={faArrowLeft} />
                  Back
                </Button>
              </div>
            </div>

            <div style={{ maxHeight: "55vh", overflowY: "auto", overflowX: "hidden" }} className="p-1">
              <Row className="g-2">
                {selectedSubProductObj?.subProductTypes?.map((type) => (
                  <Col key={type.id} xs={6} sm={4} lg={3} className="d-flex justify-content-center">
                    <button
                      type="button"
                      className={`btn configutar-model-selector-button ${selectedTypeObj?.id === type.id ? "selected" : ""}`}
                      onClick={() => goToBaseSelections(type)}
                    >
                      <div className="d-flex flex-column align-items-center">
                        <strong className="configutar-model-title">{type.typeName}</strong>
                        <div className="configutar-model-frame configutar-model-frame-large">
                          {type.typeImage && (
                            <img src={getImageSrc(type.typeImage)} alt={type.typeName} className="configutar-model-image configutar-model-image-large" />
                          )}
                        </div>
                      </div>
                    </button>
                  </Col>
                ))}
              </Row>
            </div>
          </Card.Body>
        </Card>
      </div>
    );
  }

  if (screen === "baseSelections") {
    return (
      <div className="py-4 sales-tool-root">
        <ConfiguratorStepper activeStep={activeStep} selections={stepSelections} onStepClick={handleStepClick} />
        <Card border="light" className="shadow-sm">

          <Card.Body>
            <div className="configutar-product-header">
              <div className="configutar-country-title">
                <h4 className="mb-0 d-flex align-items-center">
                  {selectedCountry.name} <FontAwesomeIcon icon={faArrowRight} className="mx-2 text-muted" size="sm" /> {selectedCategory} <FontAwesomeIcon icon={faArrowRight} className="mx-2 text-muted" size="sm" /> {selectedSubProductObj?.subProductName} <FontAwesomeIcon icon={faArrowRight} className="mx-2 text-muted" size="sm" /> {selectedTypeObj?.typeName}
                </h4>
              </div>

              <Button
                variant="outline-primary"
                className="configutar-back-button"
                onClick={() => {
                  setSelectedTypeObj(null);
                  setVrsSelection(null);
                  setDuTypeSelection(null);
                  setFlowRateSelection(null);
                  setScreen("subProductTypes");
                }}
              >
                <FontAwesomeIcon icon={faArrowLeft} />
                Back
              </Button>
            </div>

            {loadingModelOptions ? (
              <div className="text-center py-5">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading models...</span>
                </div>
              </div>
            ) : baseOptionsError ? (
              <div className="alert alert-danger text-center">Data failed to load. Please try again.</div>
            ) : (
              <div className="row g-3">


                <div className="col-12 col-md-6">
                  <Form.Group>
                    <Form.Label>Model (P = Product, H = Hose, D = Display, D = Dispense / side)</Form.Label>
                    <Form.Select
                      value={selectedModel || ""}
                      onChange={(e) => {
                        const nextModel = e.target.value;
                        setSelectedModel(nextModel);
                        setDuTypeSelection(null);
                        setFlowRateSelection(null);
                        setVrsSelection(null);
                      }}
                      className={!selectedModel ? "border-warning border-2" : "border-success border-2"}
                    >
                      <option value="">Select Model</option>
                      {modelOptions.map((m, i) => {
                        const val = typeof m === "object" ? m.modelNumber || m.modelName || m.model : m;
                        const label = val;
                        return (
                          <option key={val || i} value={val}>
                            {label}
                          </option>
                        );
                      })}
                    </Form.Select>
                  </Form.Group>
                </div>

                <div className="col-12 col-md-6">
                  <Form.Group>
                    <Form.Label>
                      DU Type {loadingDuTypeOptions && <span className="spinner-border spinner-border-sm text-primary ms-2" />}
                    </Form.Label>
                    <Form.Select
                      value={duTypeSelection || ""}
                      onChange={(e) => {
                        setDuTypeSelection(e.target.value);
                        setFlowRateSelection(null);
                        setVrsSelection(null);
                      }}
                      disabled={!selectedModel || loadingDuTypeOptions}
                      className={!duTypeSelection ? "border-warning border-2" : "border-success border-2"}
                    >
                      <option value="">Select DU Type</option>
                      {duTypeOptions.map((d, i) => {
                        const val = typeof d === "object" ? d.duType || d.typeName || d.type : d;
                        const label = val;
                        return (
                          <option key={val || i} value={val}>
                            {label}
                          </option>
                        );
                      })}
                    </Form.Select>
                  </Form.Group>
                </div>

                <div className="col-12 col-md-6">
                  <Form.Group>
                    <Form.Label className="mt-2">
                      Flow Rate (h = 40 LPM, H = 80 LPM, H1 = 120 LPM) {loadingFlowRateOptions && <span className="spinner-border spinner-border-sm text-primary ms-2" />}
                    </Form.Label>


                    <Form.Select
                      value={flowRateSelection || ""}
                      onChange={(e) => {
                        setFlowRateSelection(e.target.value);
                        setVrsSelection(null);
                      }}
                      disabled={!duTypeSelection || loadingFlowRateOptions}
                      className={!flowRateSelection ? "border-warning border-2" : "border-success border-2"}
                    >
                      <option value="">Select Flow Rate</option>
                      {flowRateOptions.map((f, i) => {
                        const val = typeof f === "object" ? f.flowRate : f;
                        const label = val;
                        return (
                          <option key={val || i} value={val}>
                            {label}
                          </option>
                        );
                      })}
                    </Form.Select>
                  </Form.Group>
                </div>

                <div className="col-12 col-md-6">
                  <Form.Group>
                    <Form.Label className="mt-2">VRS (Vapour Recovery System)</Form.Label>
                    <Form.Control
                      type="text"
                      value={vrsSelection || ""}
                      disabled
                      readOnly
                      placeholder={loadingConfig ? "Loading..." : "VRS value"}
                      className="border-success border-2 bg-light"
                    />
                  </Form.Group>
                </div>
              </div>
            )}
            <div className="mt-3">
              <div className="d-flex flex-column align-items-center mt-4">
                {componentsError && <div className="alert alert-danger w-100 text-center mb-3">Data failed to load. Please try again.</div>}

                <div className="d-flex justify-content-center gap-4">
                  <Button
                    variant={standardOrCustom === "standard" || hoveredBtn === "standard" ? "success" : "warning"}
                    className="py-2 fw-bold"
                    style={{ width: "180px" }}
                    onMouseEnter={() => setHoveredBtn("standard")}
                    onMouseLeave={() => setHoveredBtn(null)}
                    onClick={() => fetchComponents("standard", "customConfigurator")}
                    disabled={!isStep2Ready || loadingComponents}
                  >
                    {loadingComponents && standardOrCustom === "standard" ? <span className="spinner-border spinner-border-sm me-2" /> : null}
                    Standard
                  </Button>
                  <Button
                    variant={standardOrCustom === "custom" || hoveredBtn === "custom" ? "success" : "warning"}
                    className="py-2 fw-bold"
                    style={{ width: "180px" }}
                    onMouseEnter={() => setHoveredBtn("custom")}
                    onMouseLeave={() => setHoveredBtn(null)}
                    onClick={() => fetchComponents("custom", "customConfigurator")}
                    disabled={!isStep2Ready || loadingComponents}
                  >
                    {loadingComponents && standardOrCustom === "custom" ? <span className="spinner-border spinner-border-sm me-2" /> : null}
                    Custom
                  </Button>
                </div>
              </div>

              {standardOrCustom === "custom" && screen !== "customConfigurator" ? (
                <div className="mt-3">
                  <div className="alert alert-info" role="alert">
                    Custom configuration enabled.
                  </div>
                </div>
              ) : null}

              {standardOrCustom === "standard" ? (

                <div className="mt-3">
                  <div className="alert alert-info" role="alert">
                    Standard package loading is placeholder (next: load predefined standard configuration package).
                  </div>
                </div>
              ) : null}
            </div>
          </Card.Body>
        </Card>
      </div>
    );
  }

  if (screen === "customConfigurator") {
    const isCommercialDataFilled = 
      commercialData.customerName.trim() !== "" &&
      commercialData.customerAddress.trim() !== "" &&
      commercialData.country !== "" &&
      commercialData.currency !== "" &&
      commercialData.paymentTerms !== "" &&
      commercialData.deliveryTerms !== "" &&
      commercialData.deliveryTimeline !== "" &&
      commercialData.expectedPODate !== "" &&
      commercialData.quantity !== "" &&
      commercialData.uploadedFile !== null;
      // commercialData.remarks.trim() !== "";

    return (
      <div className="py-1 sales-tool-root">

        <Card border="light" className="shadow-sm">
          <Card.Body>
            <div className="configutar-product-header">
              <div className="configutar-country-title">
                <h4 className="mb-0">{standardOrCustom === "standard" ? "Standard Configurator" : "Custom Configurator"}</h4>
              </div>

              <Button variant="outline-primary" className="configutar-back-button" onClick={() => setScreen("baseSelections")}>
                <FontAwesomeIcon icon={faArrowLeft} />
                Back
              </Button>
            </div>

            <div className="mt-1">


              {loadingConfig && <div className="text-center py-3 rounded mb-3" style={{ border: "2px solid #457756", color: "#457756" }}>Loading configuration...</div>}
              {configError && <div className="alert alert-danger text-center">Data failed to load. Please try again.</div>}
              {!loadingConfig && !configError && configData && (
                <div className="mb-3">
                  <div className="text-dark bg-white p-2 rounded d-flex flex-wrap gap-4 small justify-content-around" style={{ border: "3px solid #457756" }}>
                    <div><span className="text-muted">Type:</span> <b className="ms-1">{Array.isArray(configData) ? configData[0]?.type : configData?.type}</b></div>
                    <div><span className="text-muted">Model:</span> <b className="ms-1">{Array.isArray(configData) ? configData[0]?.modelNumber : configData?.modelNumber}</b></div>
                    <div><span className="text-muted">DU Type:</span> <b className="ms-1">{Array.isArray(configData) ? configData[0]?.duType : configData?.duType}</b></div>
                    <div><span className="text-muted">Flow Rate:</span> <b className="ms-1">{Array.isArray(configData) ? configData[0]?.flowRate : configData?.flowRate}</b></div>
                    <div><span className="text-muted">VRS:</span> <b className="ms-1">{Array.isArray(configData) ? configData[0]?.vrs : configData?.vrs}</b></div>
                    <div><span className="text-muted">DU Config:</span> <b className="ms-1 text-primary">{Array.isArray(configData) ? configData[0]?.duConfiguration : configData?.duConfiguration}</b></div>
                  </div>
                </div>
              )}
            </div>

            {standardOrCustom === "standard" ? (
              <>
                <div className="d-flex flex-wrap gap-2 mb-3 justify-content-between align-items-center">
                  <div className="d-flex flex-wrap gap-2">
                    {(componentsData ? Object.keys(componentsData) : tabItems).map((t) => {
                      const isActive = activeTab === t;
                      const progress = isActive ? 100 : 0;
                      return (
                        <button
                          key={t}
                          type="button"
                          className={`btn btn-sm px-3 py-1`}
                          style={{
                            background: `linear-gradient(to right, #198654 ${progress}%, #f8f9fa ${progress}%)`,
                            border: isActive ? "3px solid black" : "1px solid #ced4da",
                            color: progress === 100 ? "white" : "black",
                            fontWeight: isActive ? "600" : "400",
                            minWidth: "120px"
                          }}
                          onClick={() => setActiveTab(t)}
                        >
                          {t}
                        </button>
                      );
                    })}
                  </div>
                  <div>

                    <button className="btn btn-secondary py-1 px-3 mx-2" onClick={() => setShowCommercialModal(true)} disabled={isDraftSaved}>
                      <FontAwesomeIcon icon={faSave} className="me-2" />
                      <span>{isDraftSaved ? "Saved" : "Save"}</span>
                    </button>
                    <button className="btn btn-secondary py-1 px-3 mx-2" onClick={handlePdfDownload} disabled={isPdfLoading}>
                      {isPdfLoading ? (
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      ) : (
                        <FontAwesomeIcon icon={faDownload} className="me-2" />
                      )}
                      <span>PDF</span>
                    </button>
                    {/* <button className="btn btn-secondary mx-2" onClick={handleExcelDownload}>
                      <FontAwesomeIcon icon={faDownload} className="me-2" />
                      <span>Excel</span>
                    </button> */}
                  </div>
                </div>

                <div className="bg-white p-3 rounded border shadow-sm">
                  <div style={{ height: "calc(100vh - 310px)", overflow: "auto" }}>
                    {componentsData && componentsData[activeTab] && componentsData[activeTab].length > 0 ? (
                      <Table striped bordered hover size="sm" className="mb-0 sales-custom-table">
                        <thead style={{ position: "sticky", top: 0, zIndex: 5 }}>
                          <tr>
                            <th style={{ background: "#457756", color: "white", whiteSpace: "nowrap" }}>Item Code</th>
                            <th style={{ background: "#457756", color: "white", whiteSpace: "nowrap" }}>Description</th>
                            <th style={{ background: "#457756", color: "white", whiteSpace: "nowrap" }}>Vertical</th>
                            <th style={{ background: "#457756", color: "white", whiteSpace: "nowrap" }}>Part Category</th>
                            <th style={{ background: "#457756", color: "white", whiteSpace: "nowrap" }}>Quantity </th>
                            <th style={{ background: "#457756", color: "white", whiteSpace: "nowrap" }}>supplier</th>
                          </tr>
                        </thead>
                        <tbody>
                          {componentsData[activeTab].map((item, idx) => {
                            const dynamicKey = Object.keys(item).find(k => k !== 'pkComponentId' && k !== 'ptItemCodePart' && k !== 'piDescription' && k !== 'partCategory');
                            return (
                              <tr key={item.pkComponentId || idx}>
                                <td>{item.piItemCodePart}</td>
                                <td>{item.piDescription}</td>
                                <td>{activeTab}</td>
                                <td>{item.partCategory}</td>
                                <td>{dynamicKey ? item[dynamicKey] : ''}</td>
                                <td>{item.supplier || 'N/A'}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </Table>
                    ) : (
                      <div className="text-muted p-3 text-center">No components found for this category.</div>
                    )}
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="d-flex flex-wrap gap-2 mb-3">
                  {tabItems.map((t) => {
                    const progress = getTabProgress(t);
                    const isActive = activeTab === t;
                    return (
                      <button
                        key={t}
                        type="button"
                        className="btn btn-sm px-3 py-1"
                        style={{
                          background: `linear-gradient(to right, #198654 ${progress}%, #f8f9fa ${progress}%)`,
                          border: isActive ? "3px solid black" : "1px solid #ced4da",
                          color: progress === 100 ? "white" : "black",
                          fontWeight: isActive ? "600" : "400",
                          minWidth: "120px"
                        }}
                        onClick={() => setActiveTab(t)}
                      >
                        {t}
                      </button>
                    );
                  })}
                </div>

                <div>
                  <SectionForm
                    title={activeTab}
                    options={getActiveOptions()}
                    values={getActiveValues()}
                    onChange={onChangeTabField}
                  />

                  <div className="mt-4 d-flex align-items-center gap-3">
                    <Button
                      variant="outline-primary"
                      type="button"
                      className="px-4 py-2 fw-bold"
                      disabled={!selectedCountry || getTabProgress(activeTab) !== 100}
                      onClick={handleSaveTab}
                    >
                      Save Tab
                    </Button>

                    {canSubmit ? (
                      <>
                        <Button
                          variant="primary"
                          type="submit"
                          className="px-5 py-2 fw-bold"
                          disabled={!selectedCountry}
                          onClick={() => setSubmitted(true)}
                        >
                          Submit Configuration
                        </Button>

                        {submitted ? (
                          <div className="alert alert-success m-0 py-2 px-3" role="alert">
                            Submitted!
                          </div>
                        ) : null}
                      </>
                    ) : (
                      <div className="text-muted small">
                        (Submit becomes available after saving all tabs)
                      </div>
                    )}
                  </div>
                </div>
              </>
            )}

            {/* Commercial Terms Modal */}
            <Modal show={showCommercialModal} onHide={() => setShowCommercialModal(false)} size="lg" centered>
              <Modal.Header closeButton>
                <Modal.Title>Commercial Terms</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Form>
                  <Row className="mb-3">
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label>Customer Name</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter Customer Name"
                          autoComplete="off"
                          value={commercialData.customerName}
                          onChange={(e) => setCommercialData({...commercialData, customerName: e.target.value})}
                          className={!commercialData.customerName ? "border-warning border-2" : "border-success border-2"}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label>Customer Address</Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={1}
                          placeholder="Enter Customer Address"
                          autoComplete="off"
                          value={commercialData.customerAddress}
                          onChange={(e) => setCommercialData({...commercialData, customerAddress: e.target.value})}
                          className={!commercialData.customerAddress ? "border-warning border-2" : "border-success border-2"}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  
                  <Row className="mb-3">
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label>Country</Form.Label>
                        <Form.Select 
                          value={commercialData.country} 
                          onChange={handleCountryChange}
                          className={!commercialData.country ? "border-warning border-2" : "border-success border-2"}
                        >
                          <option value="">Select Country</option>
                          {countries.map(c => <option key={c.id} value={c.name}>{c.name}</option>)}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label>Currency</Form.Label>
                        <Form.Select 
                          value={commercialData.currency} 
                          onChange={(e) => setCommercialData({...commercialData, currency: e.target.value})}
                          className={!commercialData.currency ? "border-warning border-2" : "border-success border-2"}
                        >
                          <option value="">Select Currency</option>
                          <option value="INR">INR</option>
                          <option value="USD">USD</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label>Payment Terms</Form.Label>
                        <Form.Select 
                          value={commercialData.paymentTerms} 
                          onChange={(e) => setCommercialData({...commercialData, paymentTerms: e.target.value})}
                          className={!commercialData.paymentTerms ? "border-warning border-2" : "border-success border-2"}
                        >
                          <option value="">Select Payment Terms</option>
                          <option value="100% advance">100% advance</option>
                          <option value="50% advance, 50% During Invoice">50% advance, 50% During Invoice</option>
                          <option value="30 days after Invoice">30 days after Invoice</option>
                          <option value="45 days after Invoice">45 days after Invoice</option>
                          <option value="60 days after invoice">60 days after invoice</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label>Delivery Terms</Form.Label>
                        <Form.Select 
                          value={commercialData.deliveryTerms} 
                          onChange={(e) => setCommercialData({...commercialData, deliveryTerms: e.target.value})}
                          className={!commercialData.deliveryTerms ? "border-warning border-2" : "border-success border-2"}
                        >
                          <option value="Ex Works">Ex Works</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                  </Row>
                  
                  <Row className="mb-3">
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label>Delivery Timeline</Form.Label>
                        <Form.Select 
                          value={commercialData.deliveryTimeline} 
                          onChange={(e) => setCommercialData({...commercialData, deliveryTimeline: e.target.value})}
                          className={!commercialData.deliveryTimeline ? "border-warning border-2" : "border-success border-2"}
                        >
                          <option value="">Select Delivery Timeline</option>
                          <option value="4 weeks">4 weeks</option>
                          <option value="8 weeks">8 weeks</option>
                          <option value="12 to 16 weeks">12 to 16 weeks</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                     <Col md={6}>
                      <Form.Group>
                        <Form.Label>Quantity</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter Quantity"
                          autoComplete="off"
                          value={commercialData.quantity}
                          className={!commercialData.quantity ? "border-warning border-2" : "border-success border-2"}
                          onChange={(e) => {
                            const val = e.target.value;
                            if (/^\d*$/.test(val)) {
                              setCommercialData({...commercialData, quantity: val});
                            }
                          }}
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label>Expected PO Date</Form.Label>
                        <Form.Control
                          type="date"
                          min={new Date().toISOString().split("T")[0]}
                          value={commercialData.expectedPODate}
                          onChange={(e) => setCommercialData({...commercialData, expectedPODate: e.target.value})}
                          className={!commercialData.expectedPODate ? "border-warning border-2" : "border-success border-2"}
                        />
                      </Form.Group>
                    </Col>
                    {/* <Col md={6}>
                      <Form.Group>
                        <Form.Label>Remarks</Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={1}
                          placeholder="Enter Remarks"
                          autoComplete="off"
                          value={commercialData.remarks}
                          onChange={(e) => setCommercialData({...commercialData, remarks: e.target.value})}
                          className={!commercialData.remarks ? "border-warning border-2" : "border-success border-2"}
                        />
                      </Form.Group>
                    </Col> */}

                      
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label>Upload Document (PDF, Excel,ZIP)</Form.Label>
                        <Form.Control
                          type="file"
                          accept=".pdf, .xls, .xlsx, .doc, .docx, .zip"
                          onChange={(e) => {
                            const file = e.target.files[0];
                            if (file) {
                              const reader = new FileReader();
                              reader.readAsDataURL(file);
                              reader.onload = () => {
                                let result = reader.result;
                                if (file.name.toLowerCase().endsWith('.zip')) {
                                  const base64Data = result.split(',')[1];
                                  result = `data:@file/zip;base64,${base64Data}`;
                                }
                                setCommercialData((prev) => ({ ...prev, uploadedFile: result }));
                              };
                            } else {
                              setCommercialData((prev) => ({ ...prev, uploadedFile: null }));
                            }
                          }}
                        />
                      </Form.Group>
                    </Col>
               
                  </Row>

                

                  <Row className="mb-3">
                    <Col md={12}>
                      <Form.Group>
                        <Form.Label>Certifications</Form.Label>
                        <div className="d-flex flex-wrap gap-3">
                          {["ATEX", "OIML", "PESO", "CDAC", "TAM (LM)", "EMI/EMC", "IP54/ IP23"].map((cert) => (
                            <Form.Check
                              key={cert}
                              type="checkbox"
                              id={`cert-${cert}`}
                              label={cert}
                              checked={commercialData.certifications?.includes(cert) || false}
                              onChange={(e) => {
                                const isChecked = e.target.checked;
                                setCommercialData((prev) => {
                                  const prevCerts = prev.certifications || [];
                                  if (isChecked) {
                                    return { ...prev, certifications: [...prevCerts, cert] };
                                  } else {
                                    return { ...prev, certifications: prevCerts.filter((c) => c !== cert) };
                                  }
                                });
                              }}
                            />
                          ))}
                        </div>
                      </Form.Group>
                    </Col>
                  </Row>
                  
                 
                </Form>
              </Modal.Body>
              <Modal.Footer>
                {/* <Button variant="secondary" onClick={() => setShowCommercialModal(false)} disabled={isDraftSaving}>
                  Close
                </Button> */}
                <Button variant="primary" onClick={handleSaveAsDraft} disabled={isDraftSaving || !isCommercialDataFilled || isDraftSaved}>
                  {isDraftSaving ? <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span> : null}
                  {isDraftSaved ? "Saved" : "Save as draft"}
                </Button>
              </Modal.Footer>
            </Modal>
          </Card.Body>
        </Card>
      </div>
    );
  }





  return (
    <div className="py-3 sales-tool-root">
      <ConfiguratorStepper activeStep={activeStep} selections={stepSelections} onStepClick={handleStepClick} />
      <Card border="light" className="shadow-sm">
        <Card.Header className="mt-2 d-flex justify-content-between align-items-center">

          <h5 className="head mb-2 mt-2" style={{ fontSize: '1.1rem' }}>Configurator</h5>
          {sessionStorage.getItem("role") === "admin" && (
            <Button variant="primary" size="sm" onClick={() => setShowCreateModal(true)}>
              + Create Product
            </Button>
          )}

        </Card.Header>

        <CreateProductForm show={showCreateModal} onHide={() => setShowCreateModal(false)} />

        <Card.Body className="p-2 p-md-3">
          <div className="configutar-map-container">
            <div className="configutar-zoom-controls">
              <Button
                variant="light"
                size="sm"
                title="Zoom out"
                onClick={zoomOut}
                className="configutar-zoom-button"
              >
                -
              </Button>
              <Button
                variant="light"
                size="sm"
                title="Zoom in"
                onClick={zoomIn}
                className="configutar-zoom-button"
              >
                +
              </Button>
            </div>

            <div
              className={`configutar-map-layer ${mapZoomClasses[mapZoomIndex]}`}
            >
              <img
                src={salesMap}
                alt="World Map"
                className={`configutar-map-image ${mapZoomClasses[mapZoomIndex]}`}
                loading="lazy"
              />

              {countries.map((country) => (
                <button
                  key={country.id}
                  type="button"
                  title={`Show ${country.name} products`}
                  onClick={() => {
                    // Step-2 prerequisites: block if access is not enabled.
                    // NOTE: temporary mock allowedCountries until backend integration.
                    const allowedCountries = ["India", "Portugal", "USA", "Dubai", "Canada"];
                    if (!allowedCountries.includes(country.name)) {
                      setAccessError("Access is not enabled for this country.");
                      return;
                    }

                    setAccessError("");
                    setSelectedCountry(country);
                    setScreen("countryProducts");
                  }}
                  className={`configutar-map-marker ${country.markerClass}`}
                >
                  <FontAwesomeIcon icon={faMapMarkerAlt} />
                  <span className="configutar-marker-label">
                    {country.name}
                  </span>
                </button>
              ))}
            </div>
          </div>

          {/* <small className="d-block mt-2 text-muted">
            Click on location pin to view products for that country.
          </small> */}
        </Card.Body>
      </Card>
    </div>
  );
};

export default Configutar;
